"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteBanner = exports.postBanner = exports.getBanner = exports.GLOBAL_BANNER_CLASS_ID = void 0;
const account_1 = require("../../features/base/account");
const functions_1 = require("../functions");
const getToken = () => (0, account_1.getAccessToken)(APP.store.getState);
/** 전체(기본) 배너를 가리키는 class_id 값 — 서버 규약: 빈 문자열 */
exports.GLOBAL_BANNER_CLASS_ID = '';
// (배너) 배너 조회 — 클래스 개별 설정이 없으면 전체 설정을 응답, 아무것도 없으면 result = null
// ★ class_id 는 필수. 빈 값(전체 배너 직접 조회) 요청은 보내지 않는다 — 전체 배너 현황은
//   클래스 조회 결과(result.class_id === '' 인 응답)로만 파악한다(2026-09-18 운영 요청).
const getBanner = async (class_id) => {
    if (!class_id) {
        return Promise.reject('class_id 가 없는 배너 조회는 지원하지 않습니다.');
    }
    const queryString = (0, functions_1.objectToQueryString)({ class_id });
    const url = `/api/mimac/v1/banner?${queryString}`;
    return (0, functions_1.fetchData)(url, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
exports.getBanner = getBanner;
// (배너) 배너 설정 — 등록·수정 겸용(upsert). class_id 빈 값이면 전체 설정.
// 전체 설정은 `default` 관리자가 파트너 ID(X-Tenant-ID)를 지정해야 한다.
const postBanner = async (data) => {
    const url = `/api/mimac/v1/admin/banner`;
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
            ...(data.tenant_id ? { 'X-Tenant-ID': data.tenant_id } : {}),
        },
        body: JSON.stringify(data.props),
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.postBanner = postBanner;
// (배너) 배너 삭제 — class_id 빈 값이면 전체 설정 삭제.
// 전체 설정 삭제는 설정 API 와 같이 X-Tenant-ID 헤더가 **필수**(서버 2026-09-21 수정, 헤더 없으면 이전엔 404).
const deleteBanner = async (data) => {
    const url = `/api/mimac/v1/admin/banner/delete`;
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
            ...(data.tenant_id ? { 'X-Tenant-ID': data.tenant_id } : {}),
        },
        body: JSON.stringify({ class_id: data.class_id }),
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.deleteBanner = deleteBanner;
